import { Process } from "model/process/Process";
import * as React from "react";
import { AppActions, Types } from "reducers/AppReducer";

export const setProcesses = (
    dispatch: React.Dispatch<AppActions>,
    processes: Process[],
) => {
    dispatch({
        type: Types.SET_INTEGRATIONS,
        payload: {
            integrations: {
                processes: processes,
            },
        },
    });
};

export const appendProcesses = (
    dispatch: React.Dispatch<AppActions>,
    processes: Process[],
) => {
    dispatch({
        type: Types.APPEND_INTEGRATIONS,
        payload: {
            integrations: {
                processes: processes,
            },
        },
    });
};
